/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', () => {
          const targetIndex = item.dataset.tabIndex === undefined ? i : Number(item.dataset.tabIndex);
          this.buttons.toggleActiveClass(targetIndex);
          OverlayManager.open(this.drawer);
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}